import React from 'react';
import { LucideCrop as LucideProps } from 'lucide-react';
import { Users as UsersIcon } from 'lucide-react';

export const Users = UsersIcon;

export const RiyalIcon = (props: LucideProps) => {
  return (
    <img 
      src="https://i.ibb.co/4RJGgC1L/riyal.png" 
      alt="Riyal"
      width={props.size || 24}
      height={props.size || 24}
      style={{ 
        display: 'inline-block',
        verticalAlign: 'middle',
        color: props.color || 'currentColor'
      }}
      {...props}
    />
  );
};